import { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Button } from "antd";
import { t } from "i18next";

export const EnterBlog = () => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                    }
                });
            },
            { threshold: 0.5 } // %50 görünür olunca tetiklenir
        );

        if (containerRef.current) observer.observe(containerRef.current);

        return () => {
            if (containerRef.current) observer.unobserve(containerRef.current);
        };
    }, []);

    useEffect(() => {
        if (isVisible && videoRef.current) {
            videoRef.current.play().catch(() => { }); // autoplay izin sorunlarını engelle
        }
    }, [isVisible]);

    return (
        <div
            ref={containerRef}
            style={{
                position: "relative",
                borderRadius: "15px",
                overflow: "hidden",
                minHeight: "250px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 8px 25px rgba(0,0,0,0.15)"
            }}
        >
            {/* Video arka plan */}
            <video
                ref={videoRef}
                src="https://portfoliom-blog.sirv.com/blog/An_ultrafuturistic_technological_20250917160.mp4"
                muted
                playsInline
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                    zIndex: 0,
                    opacity: '0.7'
                }}
            />

            {/* Yarı saydam overlay */}
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    backgroundColor: "rgba(0,0,0,0.4)",
                    zIndex: 1
                }}
            />

            {/* İçerik */}
            <motion.div
                style={{
                    position: "relative",
                    zIndex: 2,
                    textAlign: "center",
                    color: "white",
                    padding: "20px",
                    maxWidth: "600px"
                }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
            >
                <motion.h2
                    style={{ fontSize: "32px", fontWeight: "bold", marginBottom: "15px" }}
                    initial={{ y: -10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.8 }}
                >
                    {t("enterBlogTitle")}
                </motion.h2>

                <motion.p
                    style={{ fontSize: "16px", marginBottom: "25px", lineHeight: 1.5 }}
                    initial={{ y: 10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    {t("enterBlogText")}
                </motion.p>

                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                    <Button
                        type="primary"
                        size="large"
                        style={{
                            background: "linear-gradient(to right, #4f46e5, #3b82f6)",
                            border: "none",
                            borderRadius: "10px",
                            padding: "0.7rem 2rem",
                            fontWeight: 600
                        }}
                        onClick={() => (window.location.href = "/blog")}
                    >
                        {t("enterBlogButtonText")}
                    </Button>
                </motion.div>
            </motion.div>
        </div>
    );
};
